import { env } from '@/shared/config'

import type { Language } from './types'

export function isLanguage(lang: any): lang is Language {
    return env.LANG_LIST.includes(lang)
}
